export const IInitApplicationUseCaseType = Symbol('IInitApplicationUseCase');
